// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b083654e","553":"7f92fc1c","977":"4aaee3ec"}[chunkId] + ".chunk.js";
};